<template>
  <div style="min-height: 200px">
    <p style="margin-bottom: 0px"><b>Step 1:</b> {{ label }}</p>
    <div>
      <div>
        <el-upload
          :action="uploadUrl"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :show-file-list="true"
          :limit="1"
        >
          <!-- <el-button
            size="small"
            type="primary"
            class="upload-btn"
            :style="{ fontSize: '18px' }"
          >
            Click Upload
          </el-button> -->

          <span class="protein-info btn-info">
            <a style="padding: 6px 9px; margin-top: 8px" hreflang="en"
              >Click Upload</a
            >
          </span>
        </el-upload>
      </div>
    </div>
    <div v-if="pdb_chains.length > 0">
      <!-- <p> Loading protein structure</p> -->
      <iframe
        :src="`${localUrl}/files/code/iCn3D/?id=${upload_str}&auto&auto&tmp_upload`"
        frameborder="0"
        style="height: 300px; width: 500px"
      ></iframe>
      <p style="margin-bottom: 20px">
        <b>Step 2:</b> Select chains (mandatory<sup style="color: red;">★</sup>)
        <a
          style="font-style: italic; padding-left: 10px; cursor: pointer"
          @click="selectALL()"
          ># Select All Chains</a
        >
      </p>
      <el-select
        v-model="selected_chains"
        multiple
        placeholder="please select chains"
        style="width: 500px"
      >
        <el-option
          v-for="(item, i) in pdb_chains"
          :key="i"
          :label="'Chain: ' + item"
          :value="item"
        >
        </el-option>
      </el-select>
      <p style="margin: 20px 0">
        <b>Step 3:</b> Describe the structure (optional)
      </p>
      <el-input
        v-model="describe_structure"
        placeholder="describe the structure"
        style="width: 500px"
      >
      </el-input>
    </div>
  </div>
</template>

<script>
import pathUrl from "@/api/path";
export default {
  data() {
    return {
      localUrl: pathUrl.localUrl,
      upload_str: "",
      pdb_chains: [],
      selected_chains: [],
      describe_structure: "",
      isLoading: true,
    };
  },
  props: {
    uploadUrl: {
      type: String,
      required: true,
    },
    uploadIndex: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },

  },
  methods: {

    selectALL() {
      this.selected_chains = this.pdb_chains;
    },
    handleSuccess(response) {
      this.$emit("success", response, this.uploadIndex);
      this.upload_str = response.random_str;
      this.pdb_chains = response.pdb_chains;
    },
    handleRemove() {
      this.$emit("remove", this.uploadIndex);
      this.pdb_chains = [];
      this.selected_chains = [];
    },
    handleExceed() {
      this.$notify({
        title: "Warning",
        message: `Delete the old file before uploading the new file.`,
        type: "warning",
        duration: 10000,
      });
    },
    beforeUpload(file) {
      // 定义常量
      const MAX_FILE_SIZE_MB = 5;
      const ALLOWED_EXTENSIONS = ["pdb", "cif"];
      // 计算文件大小
      const fileSizeMB = file.size / 1024 / 1024;
      // 获取文件扩展名
      const fileExt = file.name.split(".").pop().toLowerCase();
      // 文件扩展名检查
      if (!ALLOWED_EXTENSIONS.includes(fileExt)) {
        this.$notify({
          title: "Warning",
          type: "warning",
          message: "Please upload the file with the suffix pdb or cif",
          duration: 10000,
        });
        return false;
      }
      // 文件大小检查
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        this.$notify({
          title: "Warning",
          type: "warning",
          message: `The file size should not exceed ${MAX_FILE_SIZE_MB}MB`,
          duration: 10000,
        });
        return false;
      }
      return true;
    },
  },

  watch: {
    selected_chains(selected_chains) {
      this.$emit("selected", selected_chains, this.uploadIndex);
    },
    
    describe_structure(newValue) {
      this.$emit("described", newValue, this.uploadIndex);
    },
  },
};
</script>

<style scoped>
</style>
